{
  "about.blocks": "معتدل سرورز",
  "about.contact": "رابطہ:",
  "about.disclaimer": "میسٹادان مفت، اوپن سورس سافٹ ویئر ہے، اور میسٹادان غیر منافع بخش کا ٹریڈ مارک ہے۔",
  "about.domain_blocks.no_reason_available": "وجوہات نہیں دستیاب",
  "about.domain_blocks.silenced.title": "محدود",
  "about.domain_blocks.suspended.title": "معطل شدہ",
  "about.rules": "سرور کے اصول",
  "account.add_or_remove_from_list": "فہرست میں شامل یا برطرف کریں",
  "account.badges.bot": "روبوٹ",
  "account.badges.group": "گروپ",
  "account.block": "مسدود @{name}",
  "account.block_domain": "{domain} سے سب چھپائیں",
  "account.block_short": "بلاک",
  "account.blocked": "مسدود کردہ",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.direct": "نجی طور پر @{name} کا ذکر کریں",
  "account.disable_notifications": "جب @{name} پوسٹ کرے تو مجھ مطلع نہ کریں",
  "account.edit_profile": "مشخص ترمیم کریں",
  "account.enable_notifications": "جب @{name} پوسٹ کرے تو مجھ مطلع کریں",
  "account.endorse": "مشکص پر نمایاں کریں",
  "account.follow": "پیروی کریں",
  "account.follow_back": "اکاؤنٹ کو فالو بیک ",
  "account.followers": "پیروکار",
  "account.followers.empty": "ہنوز اس صارف کی کوئی پیروی نہیں کرتا.",
  "account.following": "فالو کر رہے ہیں",
  "account.follows.empty": "\"یہ صارف ہنوز کسی کی پیروی نہیں کرتا ہے\".",
  "account.go_to_profile": "پروفائل پر جائیں",
  "account.hide_reblogs": "@{name} سے فروغ چھپائیں",
  "account.in_memoriam": "یادگار میں۔",
  "account.joined_short": "شمولیت",
  "account.languages": "سبسکرائب شدہ زبانیں بدلیں",
  "account.link_verified_on": "اس لنک کی ملکیت کی توثیق {date} پر کی گئی تھی",
  "account.locked_info": "اس اکاونٹ کا اخفائی ضابطہ مقفل ہے۔ صارف کی پیروی کون کر سکتا ہے اس کا جائزہ وہ خود لیتا ہے.",
  "account.media": "وسائل",
  "account.mention": "ذکر @{name}",
  "account.moved_to": "{name} نے اشارہ کیا ہے کہ ان کا نیا اکاؤنٹ اب ہے:",
  "account.mute": "خاموش @{name}",
  "account.mute_notifications_short": "نوٹیفیکیشنز کو خاموش کریں",
  "account.mute_short": "خاموش",
  "account.muted": "خاموش کردہ",
  "account.no_bio": "کوئی تفصیل نہیں دی گئی۔",
  "account.open_original_page": "اصل صفحہ کھولیں",
  "account.posts": "ٹوٹ",
  "account.report": "@{name} اطلاع کریں",
  "account.requested_follow": "{name} آپ کو فالو کرنا چھاتا ہے۔",
  "account.share": "@{name} کے مشخص کو بانٹیں",
  "account.show_reblogs": "@{name} کی افزائشات کو دکھائیں",
  "account.unblock": "@{name} کو بحال کریں",
  "account.unblock_domain": "{domain} کو نہ چھپائیں",
  "account.unblock_short": "بلاک ختم کریں",
  "account.unendorse": "مشخص پر نمایاں نہ کریں",
  "account.unfollow": "پیروی ترک کریں",
  "account.unmute": "@{name} کو با آواز کریں",
  "account.unmute_notifications_short": "نوٹیفیکیشنز کو خاموش نہ کریں",
  "account.unmute_short": "کو خاموش نہ کریں",
  "admin.dashboard.daily_retention": "ایڈمن ڈیش بورڈ کو ڈیلی چیک ان کریں",
  "admin.dashboard.monthly_retention": "ایڈمن کیش بورڈ کو منتھلی چیک ان کریں",
  "admin.dashboard.retention.average": "اوسط",
  "admin.dashboard.retention.cohort_size": "نئے یسرز",
  "alert.rate_limited.message": "\"{retry_time, time, medium} کے بعد کوشش کریں\".",
  "alert.rate_limited.title": "محدود شرح",
  "alert.unexpected.message": "ایک غیر متوقع سہو ہوا ہے.",
  "alert.unexpected.title": "ا رے!",
  "announcement.announcement": "اعلان",
  "boost_modal.combo": "آئیندہ یہ نہ دیکھنے کیلئے آپ {combo} دبا سکتے ہیں",
  "bundle_column_error.error.title": "اوف، نہیں!",
  "bundle_column_error.network.title": "نیٹ ورک کی خرابی",
  "bundle_column_error.retry": "دوبارہ کوشش کریں",
  "bundle_column_error.return": "واپس گھر جاؤ",
  "bundle_column_error.routing.title": "۴۰۴",
  "bundle_modal_error.close": "بند کریں",
  "bundle_modal_error.retry": "دوبارہ کوشش کریں",
  "column.about": "متعلق",
  "column.blocks": "مسدود صارفین",
  "column.bookmarks": "بُک مارکس",
  "column.community": "مقامی زمانی جدول",
  "column.directory": "مشخصات کا مطالعہ کریں",
  "column.domain_blocks": "پوشیدہ ڈومین",
  "column.favourites": "پسندیدہ",
  "column.follow_requests": "پیروی درخواست",
  "column.home": "خانہ",
  "column.lists": "فہرستیں",
  "column.mutes": "خاموش کردہ صارفین",
  "column.notifications": "اطلاعات",
  "column.pins": "چسپاں ٹوٹ",
  "column.public": "مجموعی زمانی جدول",
  "column_back_button.label": "واپس",
  "column_header.hide_settings": "ترتیبات کو چھپائیں",
  "column_header.moveLeft_settings": "کالم کو بائیں جانب منتقل کریں",
  "column_header.moveRight_settings": "کالم کو دائیں جانب منتقل کریں",
  "column_header.pin": "چسپاں کریں",
  "column_header.show_settings": "ترتیبات دکھائیں",
  "column_header.unpin": "رہا کریں",
  "community.column_settings.local_only": "صرف مقامی",
  "community.column_settings.media_only": "وسائل فقط",
  "community.column_settings.remote_only": "صرف خارجی",
  "compose.language.change": "زبان تبدیل کریں",
  "compose.language.search": "زبان تلاش کریں...",
  "compose_form.direct_message_warning_learn_more": "مزید جانیں",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "آپ کا اکاؤنٹ {locked} نہیں ہے. کوئی بھی آپ کے مخصوص برائے پیروکار ٹوٹ دیکھنے کی خاطر آپ کی پیروی کر سکتا ہے.",
  "compose_form.lock_disclaimer.lock": "مقفل",
  "compose_form.placeholder": "آپ کیا سوچ رہے ہیں؟",
  "compose_form.poll.duration": "مدتِ رائے",
  "compose_form.poll.switch_to_multiple": "متعدد انتخاب کی اجازت دینے کے لیے پول تبدیل کریں",
  "compose_form.poll.switch_to_single": "کسی ایک انتخاب کے لیے پول تبدیل کریں",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmation_modal.cancel": "منسوخ",
  "confirmations.block.confirm": "بلاک",
  "confirmations.delete.confirm": "ڈیلیٹ",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete_list.confirm": "ڈیلیٹ",
  "confirmations.delete_list.message": "کیا آپ واقعی اس فہرست کو مستقل طور پر ڈیلیٹ کرنا چاہتے ہیں؟",
  "confirmations.logout.confirm": "لاگ آؤٹ",
  "confirmations.logout.message": "کیا واقعی آپ لاگ آؤٹ ہونا چاہتے ہیں؟",
  "confirmations.mute.confirm": "خاموش",
  "confirmations.redraft.confirm": "ڈیلیٹ کریں اور دوبارہ ڈرافٹ کریں",
  "confirmations.unfollow.confirm": "پیروی ترک کریں",
  "conversation.delete": "گفتگو کو ڈیلیٹ کریں",
  "conversation.mark_as_read": "بطور پڑھا ہوا دکھائیں",
  "conversation.open": "گفتگو دیکھیں",
  "conversation.with": "{names} کے ساتھ",
  "directory.federated": "معروف فیڈی ورس سے",
  "directory.local": "صرف {domain} سے",
  "directory.new_arrivals": "نئے آنے والے",
  "directory.recently_active": "حال میں میں ایکٹیو",
  "dismissable_banner.dismiss": "برخاست کریں",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "یہ اس طرح نظر آئے گا:",
  "emoji_button.activity": "سرگرمی",
  "emoji_button.custom": "حسب منشا",
  "emoji_button.flags": "پرچم",
  "emoji_button.food": "عذا و مشروب",
  "emoji_button.label": "ایموجی داخل کریں",
  "emoji_button.nature": "قدرت",
  "emoji_button.not_found": "کوئی مماثل ایموجیز نہیں ملے",
  "empty_column.account_timeline": "یہاں کوئی نوٹس نہیں ہیں!",
  "empty_column.account_unavailable": "مشخص دستیاب نہیں ہے",
  "empty_column.blocks": "آپ نے ابھی کسی صارف کو مسدود نہیں کیا ہے.",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.community": "مقامی جدول خالی ہے. کچھ تحریر کریں تاکہ بات آگے بڑھے!",
  "empty_column.domain_blocks": "ابھی تک کوئی چھپا ہوا ڈومین نہیں ہے.",
  "empty_column.follow_requests": "ابھی تک آپ کی پیری کرنے کی درخواست نہیں کی ہے. جب کوئی درخواست کرے گا، ان کا نام یہاں نظر آئے گا.",
  "empty_column.hashtag": "ابھی یہ ہیش ٹیگ خالی ہے.",
  "empty_column.home": "آپ کا خانگی جدول خالی ہے! {public} دیکھیں یا شروعات کیلئے تلاش کریں اور دیگر صارفین سے ملیں.",
  "empty_column.list": "یہ فہرست ابھی خالی ہے. جب اس فہرست کے ارکان کچھ تحریر کریں گے، یہاں نظر آئے گا.",
  "empty_column.mutes": "آپ نے ابھی کسی صارف کو خاموش نہیں کیا ہے.",
  "empty_column.notifications": "ابھی آپ کیلئے کوئی اطلاعات نہیں ہیں. گفتگو شروع کرنے کے لئے دیگر صارفین سے متعامل ہوں.",
  "empty_column.public": "یہاں کچھ بھی نہیں ہے! کچھ عمومی تحریر کریں یا اس جگہ کو پُر کرنے کے لئے از خود دیگر سرورس کے صارفین کی پیروی کریں",
  "error.unexpected_crash.next_steps": "صفحے کو تازہ کرنے کی کوشش کریں. اگر کارآمد نہ ہو تو آپ کسی دیگر براؤزر یا مقامی ایپ سے ہنوز ماسٹوڈون استعمال کر سکتے ہیں.",
  "errors.unexpected_crash.report_issue": "مسئلہ کی اطلاع کریں",
  "follow_request.authorize": "اجازت دیں",
  "follow_request.reject": "انکار کریں",
  "footer.about": "متعلق",
  "getting_started.heading": "آغاز کریں",
  "hashtag.column_header.tag_mode.all": "اور {additional}",
  "hashtag.column_header.tag_mode.any": "یا {additional}",
  "hashtag.column_header.tag_mode.none": "بغیر {additional}",
  "hashtag.column_settings.select.no_options_message": "کوئی ترغیبات نہیں ملیں",
  "hashtag.column_settings.select.placeholder": "ہیش ٹیگ داخل کریں…",
  "hashtag.column_settings.tag_mode.all": "یہ تمام",
  "hashtag.column_settings.tag_mode.any": "ان میں سے کوئی",
  "hashtag.column_settings.tag_mode.none": "ان میں سے کوئی بھی نہیں",
  "hashtag.column_settings.tag_toggle": "اس کالم کے لئے مزید ٹیگز شامل کریں",
  "home.column_settings.show_reblogs": "افزائشات دکھائیں",
  "home.column_settings.show_replies": "جوابات دکھائیں",
  "intervals.full.days": "{number, plural, one {# روز} other {# روز}}",
  "intervals.full.hours": "{number, plural, one {# ساعت} other {# ساعت}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "navigation_bar.blocks": "مسدود صارفین",
  "navigation_bar.bookmarks": "بُک مارکس",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.filters": "خاموش کردہ الفاظ",
  "navigation_bar.follow_requests": "پیروی کی درخواستیں",
  "navigation_bar.follows_and_followers": "پیروی کردہ اور پیروکار",
  "navigation_bar.lists": "فہرستیں",
  "navigation_bar.logout": "لاگ آؤٹ",
  "navigation_bar.mutes": "خاموش کردہ صارفین",
  "navigation_bar.preferences": "ترجیحات",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} آپ کی پیروی کی",
  "notification.follow_request": "{name} نے آپ کی پیروی کی درخواست کی",
  "notification.own_poll": "آپ کا پول ختم ہو گیا ہے",
  "notification.reblog": "{name} boosted your status",
  "notification.status": "{name} نے ابھی ابھی پوسٹ کیا",
  "notifications.clear": "اطلاعات ہٹائیں",
  "notifications.clear_confirmation": "کیا آپ واقعی اپنی تمام اطلاعات کو صاف کرنا چاہتے ہیں؟",
  "notifications.column_settings.alert": "ڈیسک ٹاپ اطلاعات",
  "notifications.column_settings.status": "New toots:",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
